import { createContext, useContext } from 'react';

import { Product, ProductLocation } from '@app/types/catalog';
import { Organization } from '@app/types/organization';

type AppContextType = {
  countLimit: number;
  exhibitionPrefecture: string[];
  exhibitionProducts: Product[] | null;
  handleLoadMoreExhibitionProducts: () => Promise<void>;
  handleLoadMorePropertyProducts: () => Promise<void>;
  handlePaginationExhibitionProducts: (skip: number) => Promise<void>;
  handlePaginationPropertyProducts: (skip: number) => Promise<void>;
  isFetchingExhibitionProducts: boolean;
  isFetchingPropertyProducts: boolean;
  isLoadingMoreExhibitionProducts: boolean;
  isLoadingMorePropertyProducts: boolean;
  organization: Organization;
  prefectures: ProductLocation[] | null;
  productNextLink: {
    exhibition: string;
    property: string;
  };
  propertyPrefecture: string[];
  propertyProducts: Product[] | null;
  setExhibitionPrefecture: React.Dispatch<React.SetStateAction<string[]>>;
  setPropertyPrefecture: React.Dispatch<React.SetStateAction<string[]>>;
  totalRecordExhibition: number;
  totalRecordProperty: number;
};

export const CompanyExhibitionContext = createContext<
  AppContextType | undefined
>(undefined);

export const useCompanyExhibitionContext = (): AppContextType => {
  const context = useContext(CompanyExhibitionContext);
  if (!context) {
    return {
      countLimit: 0,
      exhibitionPrefecture: [],
      exhibitionProducts: null,
      handleLoadMoreExhibitionProducts: async () => {},
      handleLoadMorePropertyProducts: async () => {},
      handlePaginationExhibitionProducts: async () => {},
      handlePaginationPropertyProducts: async () => {},
      isFetchingExhibitionProducts: false,
      isFetchingPropertyProducts: false,
      isLoadingMoreExhibitionProducts: false,
      isLoadingMorePropertyProducts: false,
      organization: {} as Organization,
      prefectures: null,
      productNextLink: {
        exhibition: '',
        property: '',
      },
      propertyPrefecture: [],
      propertyProducts: null,
      setExhibitionPrefecture: () => {},
      setPropertyPrefecture: () => {},
      totalRecordExhibition: 0,
      totalRecordProperty: 0,
    };
  }
  return context;
};
